export default __webpack_public_path__ + "static/media/hotel_img_hi_26.3da617b0.jpg";